import React from 'react';
import styled from 'styled-components';
import {
  SocialMedia as IProps,
} from 'infrastructure/gatsby/types/social-media';
import SocialMediaComponent
  from '@shipae/components-sandbox/component/social-media';
import SocialMediaTheme
  from '@shipae/components-sandbox/component/social-media/theme';
import { Timeline } from 'react-twitter-widgets';
import config from 'src/config';

const SocialMedia: React.FC<IProps> = ({
  ...content
}) => (
  <SocialMediaComponent
    title={content.title}
    icon={(
      <img
        src={
      content.icon?.localFile?.publicURL
    }
        loading="lazy"
        alt=""
      />
)}
    theme={{
      ...SocialMediaTheme,
      Main: styled(SocialMediaTheme.Main)`
        width: auto;
      `,
    }}
  >
    {(() => {
      if (content.socialNetwork === 'twitter') {
        return (
          <Timeline
            dataSource={{
              sourceType: 'profile',
              screenName: config.twitterUsername,
            }}
            options={{
              height: '400',
            }}
          />
        );
      }
      return <div>Social network is not selected</div>;
    })()}
  </SocialMediaComponent>
);

export default SocialMedia;
